import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { PureComputed, Subscribable, SubscribableOrNullableValue } from 'knockout';
import { TopicThread } from 'models/topicThread';

export interface CommentRequestButtonVMConfig {
    comment?: SubscribableOrNullableValue<TopicThread>
    lock?: SubscribableOrNullableValue<boolean>
}

@injectable()
export default abstract class CommentRequestButtonVM {
    protected comment: Subscribable<TopicThread | undefined>
    protected isLocked: Subscribable<boolean>

    labels = labels;

    isBusy = ko.observable(false).extend({ rateLimit: 250 });

    constructor(
        @inject(wccModules.componentConfig) config: CommentRequestButtonVMConfig,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        this.comment = ko.flattenComputed(config.comment);

        const isLocked = ko.flattenComputed(config.lock, false);
        this.isLocked = ko.pureComputed(() => this.isBusy() || isLocked());

        const isVisible = ko.pureComputed(() => this.checkIfVisible());

        //wait for full component construction
        requestAnimationFrame(() => {
            ko.applyBindingsToNode(info.element, {
                'visible': isVisible
            }, this);
        });
    }

    protected checkIfVisible() {
        return this.comment() != undefined;
    }
}